export enum Gender {
  Male = 1,
  Female = 2
}

export enum Accomodation{
  Investor = 1,
  Employee = 2
}